export default __webpack_public_path__ + "static/media/magneto.367c13b0.svg";